import React from "react";
import ReactDOM from "react-dom/client";
import {
  MutationCache,
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ApiError } from "./api/client";
import { initTheme } from "./store/theme";
// Самохостинг шрифтов Geist / Geist Mono (@fontsource, вместо Google Fonts CDN):
// семейства "Geist"/"Geist Mono" — ровно как в tailwind.config.ts fontFamily.
import "@fontsource/geist/400.css";
import "@fontsource/geist/500.css";
import "@fontsource/geist/600.css";
import "@fontsource/geist/700.css";
import "@fontsource/geist-mono/400.css";
import "@fontsource/geist-mono/500.css";
import "@fontsource/geist-mono/600.css";
import "./index.css";

// Apply the persisted light/dark theme before the first paint (no flash of light).
initTheme();

/** On any 401 from queries/mutations, bounce to the login screen (session expired). */
function handleAuthError(error: unknown) {
  if (error instanceof ApiError && error.status === 401) {
    if (window.location.pathname !== "/login") {
      window.location.assign("/login");
    }
  }
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: handleAuthError }),
  mutationCache: new MutationCache({ onError: handleAuthError }),
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, staleTime: 30_000, retry: false },
  },
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
